export enum TerminationDateInputType {

  DATEPICKER_DAY = "DATEPICKER_DAY",
  DATEPICKER_MONTH = "DATEPICKER_MONTH"

}
